import React, { Dispatch, SetStateAction } from 'react';
import { useCategoriesByType } from '@app/sdk';

export function CategorySelector({
  selectedCategory,
  setSelectedCategory,
  type,
}: {
  selectedCategory: string;
  type: 'product' | 'merchant';
  setSelectedCategory: Dispatch<SetStateAction<string>>;
}) {
  const { data: categories } = useCategoriesByType({ type });
  return (
    <div className="field">
      <div className="ui labeled right input">
        <div className="ui label">Category</div>
        <div className="ui input">
          <select
            key={JSON.stringify(categories)}
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}>
            <option key={'select'} value={''}>
              Select...
            </option>
            {categories?.map((category) => {
              return (
                <option key={category.id} value={category.id}>
                  {category.name} (id: {category.id})
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </div>
  );
}
